import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AnalyticsRouteTracker from "./analytics/AnalyticsRouteTracker";
import App from './App';
import { ensureFirebaseSession, isGoogleUser } from './authSession';
import { loadGoogleIdentityScript, initGoogleSignIn } from './googleSignIn';

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

/* ===============================
   1. Cargar Google Analytics
   =============================== */
function loadGoogleAnalyticsScript() {
  return new Promise((resolve, reject) => {
    if (!GA_ID) {
      console.warn("[GA] Missing REACT_APP_GA_MEASUREMENT_ID");
      resolve();
      return;
    }

    if (document.getElementById('ga4-script')) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = 'ga4-script';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    script.async = true;

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }

      window.gtag = gtag;
      window.gtag('js', new Date());
      window.gtag('config', GA_ID, {
        send_page_view: false,
      });

      console.log("[GA] initialized", GA_ID);
      resolve();
    };

    script.onerror = reject;
    document.head.appendChild(script);
  });
}

/* ===============================
   2. Bootstrap de la app
   =============================== */
async function bootstrap() {
  try {
    await loadGoogleAnalyticsScript();
  } catch (err) {
    console.error("[GA] failed to load", err);
  }

  // Every API call needs a Firebase ID token, so the app doesn't render
  // until at least an anonymous session exists (Firebase restores a prior
  // Google session automatically if there is one).
  const sessionUser = await ensureFirebaseSession();

  if (!isGoogleUser(sessionUser)) {
    try {
      await loadGoogleIdentityScript();
      initGoogleSignIn();
    } catch (err) {
      console.error("Google Identity failed to load", err);
    }
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  console.log("GA ID:", process.env.REACT_APP_GA_MEASUREMENT_ID);
  root.render(
    <BrowserRouter>
      <AnalyticsRouteTracker />
      <App />
    </BrowserRouter>
  );
}

bootstrap();
